import {
  Home,
  SignIn,
  SignUp,
  Locations,
  ManageAccount,
  ForgotPassword,
  Dashboard,
  PriceTable,
  InsuranceHub,
} from 'pages';
import BusinessDashboard from 'pages/business';
import BusinessSignUp from 'pages/business/sign-up';

// Feature flag — keep the Insurance route out until launch.
const INSURANCE_ENABLED = process.env.REACT_APP_INSURANCE_ENABLED === 'true';

export const pageNames = {
  home: `Home`,
  signUp: `SignUp`,
  companySignUp: `SignUp`,
  businessSignUp: `SignUp`,
  signIn: `SignIn`,
  forgotPassword: `ForgotPassword`,
  locations: `Locations`,
  manageAccount: `ManageAccount`,
  priceTable: 'PriceTable',
  business: 'Business',
  insurance: 'Insurance',
};

export const routePaths = {
  home: `/`,
  signUp: `/sign-up`,
  companySignup: `/:company/sign-up`,
  businessSignUp: '/business-signup',
  signIn: `/sign-in`,
  forgotPassword: `/forgot-password`,
  locations: `/locations`,
  manageAccount: `/manage-account`,
  priceTable: `/price-table`,
  business: '/business',
  insurance: `/insurance`,
};

export const PAGE_ENUMS = {
  HOME: 1,
  MANAGE_ACCOUNT: 2,
  LOCATIONS: 3,
  INSURANCE: 4,
};

export const privateRoutes = {
  [routePaths.home]: {
    name: pageNames.home,
    path: routePaths.home,
    component: Dashboard,
    subComponent: Home,
    selectedId: PAGE_ENUMS.HOME,
  },
  [routePaths.locations]: {
    name: pageNames.locations,
    path: routePaths.locations,
    component: Dashboard,
    subComponent: Locations,
    selectedId: PAGE_ENUMS.LOCATIONS,
  },
  [routePaths.manageAccount]: {
    name: pageNames.manageAccount,
    path: routePaths.manageAccount,
    component: Dashboard,
    subComponent: ManageAccount,
    selectedId: PAGE_ENUMS.MANAGE_ACCOUNT,
  },
  ...(INSURANCE_ENABLED
    ? {
        [routePaths.insurance]: {
          name: pageNames.insurance,
          path: routePaths.insurance,
          component: Dashboard,
          subComponent: InsuranceHub,
          selectedId: PAGE_ENUMS.INSURANCE,
        },
      }
    : {}),

  [routePaths.business]: {
    name: pageNames.business,
    path: routePaths.business,
    component: BusinessDashboard,
    exact: true,
  },
};

export const publicRoutes = {
  [routePaths.signIn]: {
    name: pageNames.signIn,
    path: routePaths.signIn,
    component: SignIn,
  },
  [routePaths.signUp]: {
    name: pageNames.signUp,
    path: routePaths.signUp,
    component: SignUp,
  },
  [routePaths.companySignup]: {
    name: pageNames.companySignUp,
    path: routePaths.companySignup,
    component: SignUp,
  },
  [routePaths.businessSignUp]: {
    name: pageNames.businessSignUp,
    path: routePaths.businessSignUp,
    component: BusinessSignUp,
  },
  [routePaths.forgotPassword]: {
    name: pageNames.forgotPassword,
    path: routePaths.forgotPassword,
    component: ForgotPassword,
  },
  [routePaths.priceTable]: {
    name: pageNames.priceTable,
    path: routePaths.priceTable,
    component: PriceTable,
  },
};
